export default "__VITE_ASSET__5b20d311__"